import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'app/shared.service';
import { IParteTransporteFig } from '../tipos-figura/tipos-figura.component';

@Component({
    selector: 'app-partes-transporte',
    templateUrl: './partes-transporte.component.html',
    styleUrls: ['./partes-transporte.component.scss']
})
export class PartesTransporteComponent implements OnInit {
    @Input() parte: IParteTransporteFig;
    @Input() catalogo: any[] = [];

    FormPartesTransporte = new FormGroup({
        Index: new FormControl(''),
        Id: new FormControl(0),
        IdTransporte: new FormControl(null, [Validators.required, Validators.min(1)]),
    });

    constructor(
        private sharedService: SharedService
    ) { }

    ngOnInit(): void {
        this.FormPartesTransporte.valueChanges.subscribe(changes => {
            if (this.FormPartesTransporte.valid) {
                this.sharedService.setFormParteTransporte(changes);
            }
        });

        //Set form
        this.FormPartesTransporte.setValue({
            Index: this.parte?.Index,
            Id: this.parte?.Id,
            IdTransporte:this.parte?.IdTransporte,
        });
    }


    changeForm(value) {
        //console.log("🚀 ~ PartesTransporteComponent ~ changeForm ~ value:", value)
    }

}
